import {
	GIC_ISSUE_DESCRIPTION_EDITOR_ID,
	ISSUE_DESCRIPTION_EDITOR_ID,
} from '@atlassian/jira-issue-view-common-constants/src/index.tsx';
import { eventHub, findEditorId } from '@atlassian/editor-plugin-ai/EventHub';
import type { EditorExperience, ProactiveDescriptionCompleterPayload } from './types.tsx';

const FEATURE_PROACTIVE_IMPROVE_DESCRIPTION = 'proactive-improve-description';

const issueViewEditorSelector = `[data-editor-container-id="${ISSUE_DESCRIPTION_EDITOR_ID}"]`;

const gicEditorSelector = `[data-testid="${GIC_ISSUE_DESCRIPTION_EDITOR_ID}"]`;

export const generatePayloadForProactiveDescriptionCompleter = (
	url?: string,
): ProactiveDescriptionCompleterPayload => {
	return {
		linked_urls: [url ?? ''],
		feature: FEATURE_PROACTIVE_IMPROVE_DESCRIPTION,
	};
};

export const triggerEditorStreamHubEvent = (
	additionalRequestPayload: ProactiveDescriptionCompleterPayload,
	editorExperience: EditorExperience,
) => {
	const editorSelector =
		editorExperience === 'IssueView' ? issueViewEditorSelector : gicEditorSelector;
	const targetEditorId = findEditorId(editorSelector);
	if (targetEditorId) {
		eventHub.publishToEditor({
			event: 'start prompt',
			data: {
				prompt: 'issue reformatter',
				targetEditorId,
				analyticSourceId: 'jiraProactiveDescriptionCompleterFooterButton',
				additionalPayloadDataIssueReformatter: { ...additionalRequestPayload },
			},
		});
	}
};

export const isConfluenceLink = (url = '') => {
	const pattern = /\/wiki\/spaces\/[^/]+\/(?:pages|blog)\//;
	return pattern.test(url);
};
